import { type IConfig } from '-/Base/BdTable'
import { AddressSelect } from '-/Business'
import { TagInput } from '-/Common/TagInput'
import { TMapGeofenceDrawer } from '-/Base/TMap'
import { JtProjPointVillagesDisplay } from '-/Business/CommonDisplay'
import { API_POINT_ADD, API_POINT_DEL, API_POINT_EDIT, API_POINT_LIST } from '@/api/point'
import { useDetailLy, useDetailPageGetFn } from '@/hooks/useDetailLy'

export default () => {
  const { id } = useDetailLy()
  const getFn = useDetailPageGetFn(API_POINT_LIST)
  const tableConfig: IConfig = {
    title: '拆迁点位',
    getFn,
    createAction: {
      fn(data) {
        return API_POINT_ADD({ ...data, projectId: id.value! })
      }
    },
    updateAction: {
      fn(data) {
        return API_POINT_EDIT({ ...data, projectId: id.value! })
      }
    },
    deleteAction: {
      fn(data) {
        return API_POINT_DEL({ ...data, projectId: id.value! })
      }
    },
    columns: [
      {
        title: '名称',
        dataIndex: '_name',
        width: 100,
        customRender({ index }) {
          return `点位${index + 1}`
        }
      },
      {
        title: '所属地区',
        dataIndex: 'positionAddress',
        width: 150,
        isDict: true,
        form: {
          required: true,
          render({ modelRef }) {
            return <AddressSelect v-model:value={modelRef.positionAddress} />
          }
        }
      },
      {
        title: '涉及村/社区',
        dataIndex: 'positionAddressVillages',
        width: 300,
        customRender: JtProjPointVillagesDisplay,
        form: {
          required: true,
          render({ modelRef }) {
            return <TagInput v-model:value={modelRef.positionAddressVillages} placeholder='请输入涉及村/社区，多个请用逗号分隔' />
          }
        }
      },
      {
        title: '详细地址',
        dataIndex: 'positionAddressDetail',
        width: 500,
        form: {
          required: true,
          type: 'textarea'
        }
      },
      {
        title: '地理围栏',
        dataIndex: 'positionCoordinate',
        extra: true,
        form: {
          render({ modelRef }) {
            return <TMapGeofenceDrawer v-model:value={modelRef.positionCoordinate} />
          }
        }
      }
    ]
  }
  return {
    tableConfig
  }
}
